export default function getSubdomain() {
	const BANNED_SUBDOMAINS = ['www', 'gravityfox'];
	const currentSubdomain = new URL(window.location.href).host.split('.').shift();
	if (currentSubdomain && !BANNED_SUBDOMAINS.includes(currentSubdomain.toLowerCase())) {
		return currentSubdomain;
	}

	return null;
}
